export default __webpack_public_path__ + "static/media/eggs_paprika.c74412a2.jpg";